import { Address } from '../../types';
import { getAddress } from '../../utils';

export type AddressLineProps = {
  address: Address;
};

export const AddressLine = ({ address }: AddressLineProps) => (
  <>
    {address.contact.addressLine1 && <div>{address.contact.addressLine1}</div>}
    {getAddress(address) && <div>{getAddress(address)}</div>}
  </>
);
